var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    { class: _vm.$style.host },
    [
      _c(
        "MobileHeader",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [_vm._v("\n    Guest Checkout\n  ")]
      ),
      _vm._v(" "),
      _c("img", {
        class: _vm.$style.mainLogo,
        attrs: {
          srcset:
            require("@/assets/img/LOGO@2x.png") +
            ", " +
            require("@/assets/img/LOGO.png"),
          src: require("@/assets/img/LOGO.png"),
          alt: "Burger Boss"
        }
      }),
      _vm._v(" "),
      _c("GuestCheckoutModal", {
        class: _vm.$style.checkoutForm,
        on: {
          continue: _vm.checkout,
          "create-account": _vm.handleCreateAccount,
          "sign-in": _vm.handleSignIn
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/GuestCheckout.vue?vue&type=template&id=7a029824&
// module id = null
// module chunks = 